import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';


import NavBar from './NavBar';
import Calculator from './Calculator';
import NewCalculationDialog from './NewCalculationDialog';


class Project extends Component {
  render() {
    const { project, history } = this.props;
    return (
      <div className="project">
        <NavBar history={history} />
        <div className="content">
          { project.calculationIndex === -1 ? (<NewCalculationDialog />) : (<Calculator />) }
        </div>
      </div>
    );
  }
}

Project.propTypes = {
    project: PropTypes.object,
  history: PropTypes.any,
};

const mapStateToProps = (state) => {
  return {
    project: state.project,
  };
};

export default connect(
    mapStateToProps
)(Project);
